import React, { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import TipoEquipoService from "../../services/ListaVerificacion/TipoEquipoService";
import { IFilterTipoEquipo } from "../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";

export const useComboTipoEquipo = (equipoAuxiliar?:boolean) => {
  const controllerRef = useRef<AbortController>(new AbortController());
  const [filter, setFilter] = useState<IFilterTipoEquipo>({ search: "" });

  const [dataComboTipoEquipos, setDataComboTipoEquipos] = useState<
    IComboBoxOption[]
  >([]);

  const comboBoxRefTipoEquipo = useRef<IComboBox>(null);

  const onClickComboTipoEquipo = () =>
    comboBoxRefTipoEquipo.current?.focus(true);
  const _openOptionTipoEquipo = useCallback(
    () => comboBoxRefTipoEquipo.current?.focus(true),
    []
  );
  const _onkeyUpSearchTipoEquipo = (event: React.KeyboardEvent<IComboBox>) => {
    _openOptionTipoEquipo();
    let { value } = event?.target as HTMLInputElement;
    setFilter({ search: value });
  };

  const PostListComboTipoEquipo = () => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;
    if(equipoAuxiliar==undefined){
      TipoEquipoService.ListaCombo(filter,newController).then((res) => {
        if (res.status === 200) {
          setDataComboTipoEquipos(res.data);
        }
      });
    }else{
      const req:IFilterTipoEquipo={
        search: filter.search,
        equipoAuxiliar:true
      }
      TipoEquipoService.ListaCombo(req,newController).then((res) => {
        if (res.status === 200) {
          setDataComboTipoEquipos(res.data);
        }
      });
    }
    
  };

  const limpiarFilters = () => {
    setFilter({ search: "" });
  };

  useEffect(() => {
    PostListComboTipoEquipo();
  }, [filter]);

  return {
    dataComboTipoEquipos,
    comboBoxRefTipoEquipo,
    onClickComboTipoEquipo,
    _onkeyUpSearchTipoEquipo,
    limpiarFilters,
  };
};
